import { Chart } from "chart.js";
import { datalabelFont, legendConfig, legendPad, onResize, tooltipTitleFont } from "./chartJsPlugins";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { infoBubble } from "../../helpers/infoBubble";
import { fillMissingData, IarMetricSampleRow, upperizeStringify } from "./chartUtils";
import { metricChartSelectorSubscription, createChartFilterStore } from "../../helpers/charts-helper";

interface ChartsSettings {
    metric: string;
    demographic: string;
    trend: string;
}

// @ts-ignore
window.initIarBlock = function ($, blockId, config, schoolResponse, networkResponse, districtResponse, bubbleConfigs, notUseDefaultTooltip) {

   // console.log('initIarBlock', blockId )
    const defaultChartsSettingsStore = createChartFilterStore<ChartsSettings>({
        metric: "",
        demographic: "",
        trend: ""
    });
    function initSelectedCharts(filters: ChartsSettings) {

        const trends = [
            { id: `iar-math-trend_${filters.trend}_All Students_ALL`, category: 'ALL', group: 'All Students' },
            { id: `iar-math-trend_${filters.trend}_Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Economic Disadvantage' },
            { id: `iar-math-trend_${filters.trend}_Non-Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Non-Economic Disadvantage' },
            { id: `iar-math-trend_${filters.trend}_English Learner_English Learner Status`, category: 'English Learner Status', group: 'English Learner' },
            { id: `iar-math-trend_${filters.trend}_Non-English Learner_English Learner Status`, category: 'English Learner Status', group: 'Non-English Learner' },
            { id: `iar-math-trend_${filters.trend}_Female_Gender`, category: 'Gender', group: 'Female' },
            { id: `iar-math-trend_${filters.trend}_Male_Gender`, category: 'Gender', group: 'Male' },
            { id: `iar-math-trend_${filters.trend}_Non-Binary_Gender`, category: 'Gender', group: 'Non-Binary' },
            { id: `iar-math-trend_${filters.trend}_IEP_IEP Status`, category: 'IEP Status', group: 'IEP' },
            { id: `iar-math-trend_${filters.trend}_Non-IEP_IEP Status`, category: 'IEP Status', group: 'Non-IEP' },
            { id: `iar-math-trend_${filters.trend}_Asian_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian' },
            { id: `iar-math-trend_${filters.trend}_Asian/Pacific Islander (Retired Category)_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian/Pacific Islander (Retired Category)' },
            { id: `iar-math-trend_${filters.trend}_Black/African American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Black/African American' },
            { id: `iar-math-trend_${filters.trend}_Hawaiian/Pacific Islander_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Hawaiian/Pacific Islander' },
            { id: `iar-math-trend_${filters.trend}_Latinx_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Latinx' },
            { id: `iar-math-trend_${filters.trend}_Multiracial_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Multiracial' },
            { id: `iar-math-trend_${filters.trend}_Native American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Native American' },
            { id: `iar-math-trend_${filters.trend}_Not Listed_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Not Listed' },
            { id: `iar-math-trend_${filters.trend}_White_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'White' },
            { id: `iar-math-trend_${filters.trend}_Non-Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Non-Temporary Living Situation' },
            { id: `iar-math-trend_${filters.trend}_Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Temporary Living Situation' },
        ];
        const filteredTrens = trends.filter(i => i.category === filters.demographic);
        const scopedIdFn = (id: string) => `${blockId}-${id}`;
        for (let trend of filteredTrens) {
            // @ts-ignores
            new Chart(document.getElementById(scopedIdFn(trend.id)), getCategoryTrendConfig(filters.trend, trend.category, trend.group))
        }
    }
    //const snapshotChartSubscription = metricChartSelectorSubscription(`${blockId}-iar-math-demographics`);
    const demographicsChartSubscription = metricChartSelectorSubscription(`${blockId}-iar-math-demographics`);
    const trendChartSubscription = metricChartSelectorSubscription(`${blockId}-iar-math-trend-select`);

    // Subscribe to changes
    demographicsChartSubscription.subscribe(value => {
        defaultChartsSettingsStore.update(prev => ({
            ...prev,
            demographic: value
        }));
    })
    trendChartSubscription.subscribe(value => {
        defaultChartsSettingsStore.update(prev => ({
            ...prev,
            trend: value
        }));
    })
    const unsubscribeDefaultSettings = defaultChartsSettingsStore.subscribe(settings => {
        console.log("Default settings changed:", settings);
       //initSelectedCharts(settings);
    });
    window.addEventListener("beforeunload", (event) => {
        demographicsChartSubscription.unsubscribe();
        trendChartSubscription.unsubscribe();
        unsubscribeDefaultSettings();
    });


    const getTooltip = (key) => {
        return bubbleConfigs[key] ?? '';
    }
    const getCategoryMappedTooltip = (category) => {
        const mappedField = mappedBubbleConfigFieldKeys[category];
        return getTooltip(mappedField);
    }
    // @TODO create new keys for these
    const mappedBubbleConfigFieldKeys =
    {
        "ALL": "allstudents",
        "Economic Disadvantage": "economicdisadvantage",
        "English Learner Status": "englishlearner",
        "Gender": "gender",
        "Grade Level": "grade",
        "IEP Status": "iep",
        "Race/Ethnicity": "raceethnicity",
        "Temporary Living Situation Status": "stls",
    }

    function scopedId(id: string) { return `${blockId}-${id}` };
    const parentScope = '.' + scopedId('metric-block');


    function tempShaper  (response) {
        const data = [];
        for (let year of response.SchoolYears) {
            data.push(...year.Categories.map(category => ({
                ...upperizeStringify(category),
                CATEGORY_DESCRIPTION: category.CategoryDescription,
                SCHOOL_YEAR: year.SchoolYear,

                //LESSTHAN10: category.Lessthan10 == "" ? "0" : category.Lessthan10,
                LESSTHAN10: category.Lessthan10 == "" ? 0 : 1,
                //NODATA: category.NoData == "" ? "0" : category.NoData,
                NODATA: category.NoData == "" ? 0 : 1,

                NETWORK: response.Network,

                "DIDNOTMEET_NUMERATOR": category.DidnotmeetNumerator,
                "DIDNOTMEET_PERCENT": category.DidnotmeetPercent,
                "PARTIALLYMET_NUMERATOR": category.PartiallymetNumerator,
                "PARTIALLYMET_PERCENT": category.PartiallymetPercent,
                "APPROACHED_NUMERATOR": category.ApproachedNumerator,
                "APPROACHED_PERCENT": category.ApproachedPercent,
                "MEET_NUMERATOR": category.MeetNumerator,
                "MEET_PERCENT": category.MeetPercent,
                "EXCEEDS_NUMERATOR": category.ExceedsNumerator,
                "EXCEEDS_PERCENT": category.ExceedsPercent,
                "MEETSEXCEEDS_NUMERATOR": category.MeetExceedsNumerator,
                "MEETSEXCEEDS_PERCENT": category.MeetExceedsPercent,

                METRIC_TITLE: response.MetricTitle

            })))
        }
        return data;
    }
    const iarSchoolData = tempShaper(fillMissingData(schoolResponse, IarMetricSampleRow));
    const networkIARData = tempShaper(fillMissingData(networkResponse, IarMetricSampleRow));
    const districtIARData = tempShaper(fillMissingData(districtResponse, IarMetricSampleRow)); 
   
    let network = config.network
    let schoolName = config.schoolName;
    //let chartMetric = config.metricName;
    let currentYear = '2023-2024';
    let trendLabels = ["2021-2022", "2022-2023", "2023-2024"];
    let selectedCategory = "ALL";
    const yearSort = (a, b) => (trendLabels.indexOf(a.SCHOOL_YEAR) - trendLabels.indexOf(b.SCHOOL_YEAR));

    let snapshotLabels = {
        "ALL": getLabels("ALL"),
        "Race/Ethnicity": getLabels("Race/Ethnicity"),
        "Economic Disadvantage": getLabels("Economic Disadvantage"),
        "English Learner Status": getLabels("English Learner Status"),
        "Gender": getLabels("Gender"),
        "Grade Level": getGradeLabels("Grade Level"),
        "IEP Status": getLabels("IEP Status"),
        "Temporary Living Situation Status": getLabels("Temporary Living Situation Status")
    }



    const snapshotTooltipConfig = {
        enabled: true, titleFont: tooltipTitleFont, callbacks: {
            title: function (tooltipItem) {
                return ''
            }, label: function (tooltipItem) {
                let idArray = tooltipItem.chart.canvas.id.replace(scopedId(''), '').split("_");
                let desc = idArray.pop();
                let cat = idArray.pop();
                let raw = getSnapshotRaw(desc, cat);
                let data = raw[tooltipItem.dataIndex];
                let percent;
                let total;
                switch (tooltipItem.datasetIndex) {
                    case 0:
                        total = "DIDNOTMEET_NUMERATOR";
                        percent = "DIDNOTMEET_PERCENT";
                        break;
                    case 1:
                        total = "PARTIALLYMET_NUMERATOR";
                        percent = "PARTIALLYMET_PERCENT";
                        break;
                    case 2:
                        total = "APPROACHED_NUMERATOR";
                        percent = "APPROACHED_PERCENT";
                        break;
                    case 3:
                        total = "MEET_NUMERATOR";
                        percent = "MEET_PERCENT";
                        break;
                    case 4:
                        total = "EXCEEDS_NUMERATOR";
                        percent = "EXCEEDS_PERCENT";
                        break;
                }
                let line1 = [`${tooltipItem.label}- % ${tooltipItem.dataset.label}: ${data[percent]}%`];
                let line2 = `Total ${tooltipItem.dataset.label}: ${Number(data[total]).toLocaleString()}`;
                let line3 = `Total Students: ${Number(data.DENOMINATOR).toLocaleString()}`;
                line1.push(line2, line3);
                return line1;
            }
        }
    };

    const trendTooltipConfig = {
        enabled: true, titleFont: tooltipTitleFont, callbacks: {
            title: function (tooltipItem) {
                return ''
            }, label: function (tooltipItem) {
                let idArray = tooltipItem.chart.canvas.id.replace(scopedId(''), '').split("_");
                let desc = idArray.pop();
                let cat = idArray.pop();
                let dataset = idArray.pop();
                let raw = getTrendRaw(dataset, desc, cat);
                let data = raw[tooltipItem.dataIndex];
                let percent;
                let total;
                switch (tooltipItem.datasetIndex) {
                    case 0:
                        total = "DIDNOTMEET_NUMERATOR";
                        percent = "DIDNOTMEET_PERCENT";
                        break;
                    case 1:
                        total = "PARTIALLYMET_NUMERATOR";
                        percent = "PARTIALLYMET_PERCENT";
                        break;
                    case 2:
                        total = "APPROACHED_NUMERATOR";
                        percent = "APPROACHED_PERCENT";
                        break;
                    case 3:
                        total = "MEET_NUMERATOR";
                        percent = "MEET_PERCENT";
                        break;
                    case 4:
                        total = "EXCEEDS_NUMERATOR";
                        percent = "EXCEEDS_PERCENT";
                        break;
                }
                let line1 = [`${tooltipItem.label}- % ${tooltipItem.dataset.label}: ${data[percent]}%`];
                let line2 = `Total ${tooltipItem.dataset.label}: ${Number(data[total]).toLocaleString()}`;
                let line3 = `Total Students: ${Number(data.DENOMINATOR).toLocaleString()}`;
                line1.push(line2, line3);
                return line1;
            }
        }
    };


    const snapshotDatalabelConfig = {
        formatter: function (value, context) {
            let idArray = context.chart.canvas.id.replace(scopedId(''), '').split("_");
            let desc = idArray.pop();
            let cat = idArray.pop();
            let data = getSnapshotRaw(desc, cat);
            let label = Array.isArray(value) ? value[0] : value;
            let target
            switch (context.datasetIndex) {
                case 0:
                    target = "DIDNOTMEET_PERCENT";
                    break;
                case 1:
                    target = "PARTIALLYMET_PERCENT";
                    break;
                case 2:
                    target = "APPROACHED_PERCENT";
                    break
                case 3:
                    target = "MEET_PERCENT";
                    break;
                case 4:
                    target = "EXCEEDS_PERCENT";
                    break;
            }
            if (label) {
                return data[context.dataIndex][target];
            } else {
                return "Fewer than 10 students or No Data";
            }
        },
        display: function (ctx) {
            const scale = ctx.chart.scales.x;
            let value = ctx.dataset.data[ctx.dataIndex];
            let num;
            // Get size of visible bar to determine if is room for a datalabel
            // Get a positive result for exceeding, and use absolute value for below 0
            if (ctx.datasetIndex > 2) {
                num = Array.isArray(value) ? value[1] - value[0] : value;
            } else {
                num = Array.isArray(value) ? Math.abs(value[0]) - Math.abs(value[1]) : value;
            }
            let range = Math.max(scale.max - scale.min, 1);

            if (isNaN(num)) {
                return true;
            }
            return (ctx.chart.width / range) * num > 20;

        },
        color: '#000000',
        font: datalabelFont,
    };

    function trendDatalabelConfigFn() {
        return {
            
            formatter: function (value, context) {
                let idArray = context.chart.canvas.id.replace(scopedId(''), '').split("_");
                let desc = idArray.pop();
                let cat = idArray.pop();
                let dataset = idArray.pop();
                let data = getTrendRaw(dataset, desc, cat);
                let label = Array.isArray(value) ? value[0] : value;
                let target;
                switch (context.datasetIndex) {
                    case 0:
                        target = "DIDNOTMEET_PERCENT";
                        break;
                    case 1:
                        target = "PARTIALLYMET_PERCENT";
                        break;
                    case 2:
                        target = "APPROACHED_PERCENT";
                        break
                    case 3:
                        target = "MEET_PERCENT";
                        break;
                    case 4:
                        target = "EXCEEDS_PERCENT";
                        break;
                }
                if (label) {
                    return data[context.dataIndex][target];
                } else {

                    return "Fewer than 10 students or No Data";
                }
            },
            display: function (ctx) {
                const scale = ctx.chart.scales.x;
                let value = ctx.dataset.data[ctx.dataIndex];
                let num;

                // Get size of visible bar to determine if is room for a datalabel
                // Get a positive result for exceeding, and use absolute value for below 0
                if (ctx.datasetIndex > 2) {
                    num = Array.isArray(value) ? value[1] - value[0] : value;
                } else {
                    num = Array.isArray(value) ? Math.abs(value[0]) - Math.abs(value[1]) : value;
                }
                let range = Math.max(scale.max - scale.min, 1);

                if (isNaN(num)) {
                    return true;
                }
                return (ctx.chart.width / range) * num > 20;

            },
            color: '#000000',
            font: datalabelFont,
        };
    }
   

    $(".iar-math-school-trends, .iar-math-district-trends, .iar-math-network-trends").hide().removeClass('hidden');

    function getLabels(type) {
        return Array.from(new Set(iarSchoolData.filter((value) => value.CATEGORY === type)
            .map((item) => item.CATEGORY_DESCRIPTION))).sort()
    }

    function getGradeLabels(type) {
        let gradeOrder = ["PE", "PK", "PE/PK", "K", "KG", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
        return Array.from(new Set(iarSchoolData.filter((item) =>
            item.CATEGORY === type)
            .map((item) => item.CATEGORY_DESCRIPTION))).sort((a, b) => gradeOrder.indexOf(a) - gradeOrder.indexOf(b));
    }

    createSnapshot();
    setTrendChart();
    setSnapshotHeight();

    let trendSelect = document.getElementById(scopedId("iar-math-trend-select"));
    trendSelect.addEventListener("change", showTrends);

    $('#' + scopedId("iar-math-trend-select")).bind('click', function () {
        let value = $(this).find('option:selected').val();
        let vals = ["school", "network", "district"];
        // @ts-ignore
        if (vals.includes(value)) {
            displayTrend(value);
        }
    });

    $('#' + scopedId("iar-math-show-snapshot")).on("click", showSnapshot);

    function getSnapshotRaw(category, label) {
        let schoolArr = iarSchoolData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label).filter((value) => value.SCHOOL_YEAR === currentYear);
        let networkArr = networkIARData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label && snapshotLabels[category].includes(value.CATEGORY_DESCRIPTION)).filter((value) => value.SCHOOL_YEAR === currentYear);
        let districtArr = districtIARData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label && snapshotLabels[category].includes(value.CATEGORY_DESCRIPTION)).filter((value) => value.SCHOOL_YEAR === currentYear);
        const ret = [...schoolArr, ...networkArr, ...districtArr];
        return ret;
    }

    function getTrendRaw(data, category, label) {
        const iarSchoolDataL = tempShaper(fillMissingData(schoolResponse, IarMetricSampleRow));
        const networkIARDataL = tempShaper(fillMissingData(networkResponse, IarMetricSampleRow));
        const districtIARDataL = tempShaper(fillMissingData(districtResponse, IarMetricSampleRow));

        let dataset;
        switch (data) {
            case "school":
                dataset = iarSchoolDataL;
                break;
            case "network":
                dataset = networkIARDataL;
                break;
            case "district":
                dataset = districtIARDataL;
                break;
        }

        const filteredDataset = dataset.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label).sort(yearSort);
       // console.log('getTrendRaw: ', filteredDataset);

        return dataset.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label).sort(yearSort);
    }

    function getNotApproachingData(category, label) {
        let array = [];
        let approachingValues = getApproachingData(category, label);
        let rawData = getSnapshotRaw(category, label);
        rawData.forEach((value, index) => {
            let approaching = approachingValues[index][0];
            //if (value.PARTIALLYMET_PERCENT !== "NULL") {
            if (value.PARTIALLYMET_PERCENT !== null) {
                let notApproaching = parseFloat(value.PARTIALLYMET_PERCENT);
                let start = 0 - (Math.abs(approaching) + notApproaching);
                let end = 0 + approaching;
                array.push([start, end]);
            } else {
                array.push([approaching, approaching])
            }
        })
        return array;
    }

    function getApproachingData(category, label) {
        let array = [];
        let rawData = getSnapshotRaw(category, label);

        rawData.forEach((value) => {
            if (value.APPROACHED_PERCENT) {
                array.push([0 - parseFloat(value.APPROACHED_PERCENT), 0])
            } else {
                array.push([0, 0])
            }
        })
        return array;
    }

    function getExceedingData(category, label) {
        let meetingValues = getMeetingData(category, label);
        let array = [];
        let rawData = getSnapshotRaw(category, label);
        let meeting;
        let exceeding;
        rawData.forEach((value, index) => {
            if (!isNaN(parseFloat(meetingValues[index]))) {
                meeting = meetingValues[index];
            } else {
                meeting = 0;
            }
            if (!isNaN(parseFloat(value.EXCEEDS_PERCENT))) {
                exceeding = parseFloat(value.EXCEEDS_PERCENT);
            } else {
                exceeding = meeting;
            }
            let start = meeting;
            let end = meeting + exceeding;
            array.push([start, end]);
        })
        return array;
    }

    function getMeetingData(category, label) {
        let array = [];
        let rawData = getSnapshotRaw(category, label);
        rawData.forEach((value) => {
            array.push(parseFloat(value.MEET_PERCENT))
        })
        return array;
    }


    function getNotMeetingData(category, label) {
        let array = [];
        let notApproachingValues = getNotApproachingData(category, label);
        let rawData = getSnapshotRaw(category, label);

        rawData.forEach((value, index) => {
            let notApproaching = notApproachingValues[index][0];
            if (value.LESSTHAN10 == 1 || value.NODATA == 1) {
                // this is a horrific hack to get "No Data" messages to show on the chart for now. 
                // it's paired with the code in the display callback of the chart
                array.push([NaN, NaN])
                return true;
            }
            if (value.DIDNOTMEET_PERCENT !== null) {
                let notMeeting = parseFloat(value.DIDNOTMEET_PERCENT);
                let start = 0 - (Math.abs(notApproaching) + notMeeting);
                let end = 0 + notApproaching;
                array.push([start, end]);
            } else {
                array.push([notApproaching, notApproaching])
            }
        })
        return array;
    }

    function getNotApproachingTrendData(data, category, label) {
        let array = [];
        let approachingValues = getApproachingTrendData(data, category, label);
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value, index) => {
            let approaching;
            let notApproaching;

            if (!isNaN(parseFloat(approachingValues[index][0]))) {
                approaching = approachingValues[index][0];
            } else {
                approaching = 0;
            }
            if (!isNaN(parseFloat(value.PARTIALLYMET_PERCENT))) {
                notApproaching = parseFloat(value.PARTIALLYMET_PERCENT);
            } else {
                notApproaching = 0;
            }
            let start = 0 - (Math.abs(approaching) + notApproaching);
            let end = approaching;
            array.push([start, end]);
        })
        return array;
    }

    function getApproachingTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value) => {
            if (!isNaN(parseFloat(value.APPROACHED_PERCENT))) {
                array.push([0 - parseFloat(value.APPROACHED_PERCENT), 0])
            } else {
                array.push([value.APPROACHED_PERCENT, 0])
            }
        })
        return array
    }

    function getMeetingTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value) => {
            array.push(parseFloat(value.MEET_PERCENT))
        })
        return array;
    }

    function getExceedingTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        let meetingValues = getMeetingTrendData(data, category, label);
        rawData.forEach((value, index) => {
            let meeting;
            let exceeding
            if (!isNaN(parseFloat(meetingValues[index]))) {
                meeting = meetingValues[index];
            } else {
                meeting = 0;
            }
            if (!isNaN(parseFloat(value.EXCEEDS_PERCENT))) {
                exceeding = parseFloat(value.EXCEEDS_PERCENT);
            } else {
                exceeding = meeting;
            }
            let start = meeting;
            let end = meeting + exceeding;
            array.push([start, end]);
        })
        return array;
    }

    function getNotMeetingTrendData(data, category, label) {
        let array = [];
        let notApproachingValues = getNotApproachingTrendData(data, category, label);
        let rawData = getTrendRaw(data, category, label);

        rawData.forEach((value, index) => {
            let notApproaching;
            let notMeeting;
            if (value.LESSTHAN10 == 1 || value.NODATA == 1) {
                // this is a horrific hack to get "No Data" messages to show on the chart for now. 
                // it's paired with the code in the display callback of the chart
                array.push([NaN, NaN])
                return true;
            }

            if (!isNaN(parseFloat(notApproachingValues[index][0]))) {
                notApproaching = notApproachingValues[index][0];
            } else {
                notApproaching = 0;
            }
            if (!isNaN(parseFloat(value.DIDNOTMEET_PERCENT))) {
                notMeeting = parseFloat(value.DIDNOTMEET_PERCENT);
            } else {
                notMeeting = 0;
            }
            let start = 0 - (Math.abs(notApproaching) + notMeeting);
            let end = notApproaching;
            array.push([start, end]);
        })
        return array;
    }

    function getTrendData(data, category, label) {
       // console.log('getTrendData: ', data, category, label);
        let trendLabels = ["2021-2022", "2022-2023", "2023-2024"]
        return {
            labels: trendLabels,
            datasets: [
                {
                    label: 'Did Not Meet Performance Level',
                    data: getNotMeetingTrendData(data, category, label),
                    backgroundColor: '#FFA110',
                    datalabels: {
                        color: 'white'
                    }
                }
                , {
                    label: 'Partially Met Performance Level',
                    data: getNotApproachingTrendData(data, category, label),
                    backgroundColor: '#2D8494',
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Approaching Performance Level',
                    data: getApproachingTrendData(data, category, label),
                    backgroundColor: '#8B2BA1',
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Meeting Performance Level',
                    data: getMeetingTrendData(data, category, label),
                    backgroundColor: '#061A53',
                    datalabels: {
                        color: 'white'
                    }
                },
                {
                    label: 'Exceeding Performance Level',
                    data: getExceedingTrendData(data, category, label),
                    backgroundColor: '#047A6E',
                    datalabels: {
                        color: 'white'
                    }
                }]
        }
    }

    function getDropoutSnapshotData(category, label) {
        const ret = {
            labels: ['School', 'Network', 'District'],
            datasets: [
                {
                    label: 'Did Not Meet Performance Level',
                    data: getNotMeetingData(category, label),
                    backgroundColor: '#FFA110',
                },
                {
                    label: 'Partially Met Performance Level',
                    data: getNotApproachingData(category, label),
                    backgroundColor: '#2D8494',
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Approaching Performance Level',
                    data: getApproachingData(category, label),
                    backgroundColor: '#8B2BA1',
                    datalabels: {
                        color: 'white'
                    }
                },
                {
                    label: 'Meeting Performance Level',
                    data: getMeetingData(category, label),
                    backgroundColor: '#061A53',
                    datalabels: {
                        color: 'white'
                    }
                },
                {
                    label: 'Exceeding Performance Level',
                    data: getExceedingData(category, label),
                    backgroundColor: '#047A6E',
                    datalabels: {
                        color: 'white'
                    },
                }]
        }
        return ret;
    }

    function getAllSnapshotConfig(category, label) {
        return {
            type: 'bar',
            plugins: [legendPad, ChartDataLabels],
            data: getDropoutSnapshotData(category, label),
            options: {
                layout: {
                    padding: {
                        right: 50
                    }
                },
                indexAxis: 'y',
                maintainAspectRatio: false,
                onResize: onResize,
                scales: {
                    x: {
                        max: 100,
                        min: -100,
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "% of Students",
                            color: "black"
                        },
                    }, y: {
                        stacked: true,
                        grid: {
                            offset: false,
                            display: false
                        }, ticks: {
                            color: "black"
                        }
                    }
                }, plugins: {
                    datalabels: snapshotDatalabelConfig,
                    tooltip: snapshotTooltipConfig,
                    legend: legendConfig,
                }
            }
        }
    }

    function getCategoryTrendConfig(data, category, label) {
       // console.log('trendDatalabelConfig: ', trendDatalabelConfigFn())
        return {
            type: 'bar',
            plugins: [ChartDataLabels],
            data: getTrendData(data, category, label),
            options: {
                layout: {
                    padding: {
                        right: 50
                    }
                },

                onResize: onResize,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        max: 100,
                        min: -100,
                        title: {
                            display: true,
                            text: "% of Students",
                            color: "black"
                        }
                    }, y: {
                        stacked: true,
                        grid: {
                            offset: false,
                            display: false
                        }, ticks: {
                            color: "black"
                        }
                    }
                }, plugins: {
                    datalabels: trendDatalabelConfigFn(),
                    tooltip: trendTooltipConfig,
                    legend: legendConfig,
                }
            }
        }
    }

    let absenceSelect = document.getElementById(scopedId("iar-math-demographics"));
    absenceSelect.addEventListener("change", changeDropoutDemographic);

    function setSnapshotHeight() {
        let height;
        let length = snapshotLabels[selectedCategory].length;
        if (selectedCategory === "Race/Ethnicity" || "Grade") {
            height = length * 415;
        } else {
            height = length * 400;
        }
        let snapshotHeight = document.getElementById(scopedId("iar-math-snapshot-height"));
        snapshotHeight.style.height = height.toString() + "px";
    }

    function changeDropoutDemographic(event) {
        let selected = event.target.value;

        selectedCategory = selected;
        setTrendChart();
        let $retired = $("#iar-math-retired");
        setSnapshotHeight();
        switch (selected) {
            case "Race/Ethnicity":
                $retired.removeClass("hidden");
                break;
            default:
                $retired.addClass("hidden");
                break;
        }

    }

    function createSnapshotTables() {
        let rows = [schoolName, "Network", "District"];
        let columns = ["DIDNOTMEET", "PARTIALLYMET", "APPROACHED", "MEET", "EXCEEDS"]
        let categories = Object.keys(snapshotLabels);
        categories.forEach((category) => {
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }

            let labels = snapshotLabels[category];
            let parent = document.getElementById(scopedId(`iar-math-${type}-tables`));

            labels.forEach((label) => {
                let data = getSnapshotRaw(category, label);
                let categoryChartTableDiv = document.createElement('div');
                categoryChartTableDiv.classList.add('snapshot-chart');
                let header = document.createElement('p');
                let key = `${category} - ${label}`;
                const tipContent = getCategoryMappedTooltip(category);
                header.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${bubbleConfigs[mappedBubbleConfigFieldKeys[`${category} - ${label}`]]?.Title ?? label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;
                categoryChartTableDiv.appendChild(header);
                let categoryChartBox = document.createElement('div');
                categoryChartBox.classList.add("table-scrolling-wrapper");
                let categoryTable = document.createElement('table');
                categoryTable.classList.add('chart-table');
                let categoryThead = categoryTable.createTHead();
                categoryThead.insertRow(0);
                categoryThead.rows[0].insertCell(0).classList.add('light-cyan');
                categoryThead.rows[0].insertCell(1).outerHTML = `<th>Did Not Meet Performance Level</th>`;
                categoryThead.rows[0].insertCell(2).outerHTML = `<th>Partially Met Performance Level</th>`;
                categoryThead.rows[0].insertCell(3).outerHTML = `<th>Approached Performance Level</th>`;
                categoryThead.rows[0].insertCell(4).outerHTML = `<th>Meet Performance Level</th>`;
                categoryThead.rows[0].insertCell(5).outerHTML = `<th>Exceed Performance Level</th>`;

                const categoryTableBody = categoryTable.createTBody();
                data.forEach((value, index) => {
                    categoryTableBody.insertRow(index);
                    categoryTableBody.rows[index].insertCell(0).outerHTML = `<th scope='row'>${rows[index]}</th>`;
                    columns.forEach((column, i) => {
                        if (value.LESSTHAN10 == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "Fewer than 10 students";
                        } else if (value.NODATA == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "No data";
                        } else {
                            if (value[columns[i]]) {
                                categoryTableBody.rows[index].insertCell(i + 1).innerText = `${value[columns[i] + '_PERCENT'].toLocaleString()}%\n${Number(value[columns[i] + '_NUMERATOR']).toLocaleString()}`;

                            }
                        }
                    })
                })
                categoryChartBox.appendChild(categoryTable);
                categoryChartTableDiv.appendChild(categoryChartBox)
                parent.appendChild(categoryChartTableDiv)

                header.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });

            })

        })
    }

    function createTrendTables(data) {
        for (const category in snapshotLabels) {
            let columns = ["DIDNOTMEET", "PARTIALLYMET", "APPROACHED", "MEET", "EXCEEDS"]
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }
            let labels = snapshotLabels[category];
            if (category === "Grade Level") {
                labels.reverse()
            }
            let parent = document.getElementById(scopedId(`iar-math-${type}-tables-${data}-trend`));
            labels.forEach((label) => {
                let dataset = getTrendRaw(data, category, label);
                let categoryChartTableDiv = document.createElement('div');
                categoryChartTableDiv.classList.add('snapshot-chart');
                let header = document.createElement('p');
                let title;
                switch (data) {
                    case "school":
                        title = schoolName;
                        break;
                    case "network":
                        title = network
                        break;
                    case "district":
                        title = "District";
                        break;

                }
                const tipContent = getCategoryMappedTooltip(category);
                header.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;
                categoryChartTableDiv.appendChild(header);
                let categoryChartBox = document.createElement('div');
                categoryChartBox.classList.add("table-scrolling-wrapper");
                let categoryTable = document.createElement('table');
                categoryTable.classList.add('chart-table');
                let categoryThead = categoryTable.createTHead();
                categoryThead.insertRow(0);
                categoryThead.rows[0].insertCell(0).classList.add('light-cyan');
                categoryThead.rows[0].insertCell(1).outerHTML = `<th>Did Not Meet Performance Level</th>`;
                categoryThead.rows[0].insertCell(2).outerHTML = `<th>Partially Met Performance Level</th>`;
                categoryThead.rows[0].insertCell(3).outerHTML = `<th>Approached Performance Level</th>`;
                categoryThead.rows[0].insertCell(4).outerHTML = `<th>Meet Performance Level</th>`;
                categoryThead.rows[0].insertCell(5).outerHTML = `<th>Exceed Performance Level</th>`;
                const categoryTableBody = categoryTable.createTBody();
                dataset.forEach((value, index) => {
                    categoryTableBody.insertRow(index);
                    categoryTableBody.rows[index].insertCell(0).outerHTML = `<th scope='row'>${trendLabels[index]}</th>`;
                    columns.forEach((column, i) => {
                        if (value.LESSTHAN10 == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "Fewer than 10 students";
                        } else if (value.NODATA == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "No data";
                        } else {
                            if (value[columns[i]]) {
                                categoryTableBody.rows[index].insertCell(i + 1).innerText = `${value[columns[i] + '_PERCENT'].toLocaleString()}%\n${Number(value[columns[i] + '_NUMERATOR']).toLocaleString()}`;
                            }
                        }
                    })
                })
                categoryChartBox.appendChild(categoryTable);
                categoryChartTableDiv.appendChild(categoryChartBox)
                parent.appendChild(categoryChartTableDiv)

                header.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });
            })
        }
    }

    function getGradeCharts(dataset) {
        let category = "Grade Level";
        let gradesServed = snapshotLabels["Grade Level"];

        let parent = document.getElementById(scopedId(`iar-math-${dataset}-grade`));
        gradesServed.reverse().forEach((grade) => {
            let container = document.createElement("div");
            container.classList.add("trend-container");
            let title;
            switch (dataset) {
                case "school":
                    title = schoolName;
                    break;
                case "network":
                    title = network
                    break;
                case "district":
                    title = "District";
                    break;

            }
            const tipContent = getCategoryMappedTooltip(category);
            container.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${grade}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;
            let canvasDiv = document.createElement('canvas');
            canvasDiv.setAttribute('id', scopedId(`iar-math-trend_${dataset}_${grade}_Grade Level`));
            container.appendChild(canvasDiv);
            parent.insertAdjacentElement('afterbegin', container)
            container.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                infoBubble(el);
            });

            new Chart(
                // @ts-ignore
                document.getElementById(scopedId(`iar-math-trend_${dataset}_${grade}_Grade Level`)),
                getCategoryTrendConfig(dataset, category, grade)
            )
        })

    }

    function createSnapshot() {
        let categories = Object.keys(snapshotLabels);
        categories.forEach((category) => {
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }

            let labels = snapshotLabels[category];
            let parent = document.getElementById(scopedId(`iar-math-${type}-charts`));
            labels.forEach((label) => {
                let container = document.createElement("div");
                container.classList.add("snapshot-container")
                const tipContent = getCategoryMappedTooltip(category);
                container.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${bubbleConfigs[mappedBubbleConfigFieldKeys[`${category} - ${label}`]]?.Title ?? label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;

                let canvasDiv = document.createElement('canvas');
                canvasDiv.setAttribute('id', scopedId(`snapshot_iar-math_${label}_${category}`));
                container.appendChild(canvasDiv);
                parent.appendChild(container);

                container.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });


                // @ts-ignore
                new Chart(
                    // @ts-ignore
                    document.getElementById(scopedId(`snapshot_iar-math_${label}_${category}`)),
                    getAllSnapshotConfig(category, label)
                );
            })
        })

        createSnapshotTables();
    }

    // State for lazy loading - tracks which datasets have been initialized
    const loadedDatasets = {
        school: false,
        network: false,
        district: false
    };

    /**
     * Universal subscription for select elements
     * Fires callback immediately with current value and on change events
     */
    function subscribeToSelectChange(selectId: string, callback: (value: string) => void) {
        const element = document.getElementById(scopedId(selectId)) as HTMLSelectElement;
        if (!element) return;

        // Fire immediately with initial value
        callback(element.value);

        // Subscribe to changes
        element.addEventListener('change', (e) => {
            const target = e.target as HTMLSelectElement;
            callback(target.value);
        });
    }
    
    /**
     * Initialize all filter subscriptions and set up lazy loading
     */
    function initFilters() {
        // Trend/Dataset Selector (School vs Network vs District)
        subscribeToSelectChange("iar-math-trend-select", (value) => {
            if (["school", "network", "district"].includes(value)) {
                // Load charts for this dataset if not already loaded
                if (!loadedDatasets[value]) {
                    loadTrendCharts(value);
                    loadGradeCharts(value);
                    loadTrendTables(value);
                    loadedDatasets[value] = true;
                }

                // Show the relevant section
                displayTrend(value);
            }
        });
    }

    /**
     * Load trend charts for a specific dataset (school/network/district)
     */
    function loadTrendCharts(dataset: string) {
        const trends = [
            { id: `iar-math-trend_${dataset}_All Students_ALL`, category: 'ALL', group: 'All Students' },
            { id: `iar-math-trend_${dataset}_Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Economic Disadvantage' },
            { id: `iar-math-trend_${dataset}_Non-Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Non-Economic Disadvantage' },
            { id: `iar-math-trend_${dataset}_English Learner_English Learner Status`, category: 'English Learner Status', group: 'English Learner' },
            { id: `iar-math-trend_${dataset}_Non-English Learner_English Learner Status`, category: 'English Learner Status', group: 'Non-English Learner' },
            { id: `iar-math-trend_${dataset}_Female_Gender`, category: 'Gender', group: 'Female' },
            { id: `iar-math-trend_${dataset}_Male_Gender`, category: 'Gender', group: 'Male' },
            { id: `iar-math-trend_${dataset}_Non-Binary_Gender`, category: 'Gender', group: 'Non-Binary' },
            { id: `iar-math-trend_${dataset}_IEP_IEP Status`, category: 'IEP Status', group: 'IEP' },
            { id: `iar-math-trend_${dataset}_Non-IEP_IEP Status`, category: 'IEP Status', group: 'Non-IEP' },
            { id: `iar-math-trend_${dataset}_Asian_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian' },
            { id: `iar-math-trend_${dataset}_Asian/Pacific Islander (Retired Category)_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian/Pacific Islander (Retired Category)' },
            { id: `iar-math-trend_${dataset}_Black/African American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Black/African American' },
            { id: `iar-math-trend_${dataset}_Hawaiian/Pacific Islander_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Hawaiian/Pacific Islander' },
            { id: `iar-math-trend_${dataset}_Latinx_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Latinx' },
            { id: `iar-math-trend_${dataset}_Multiracial_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Multiracial' },
            { id: `iar-math-trend_${dataset}_Native American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Native American' },
            { id: `iar-math-trend_${dataset}_Not Listed_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Not Listed' },
            { id: `iar-math-trend_${dataset}_White_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'White' },
            { id: `iar-math-trend_${dataset}_Non-Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Non-Temporary Living Situation' },
            { id: `iar-math-trend_${dataset}_Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Temporary Living Situation' },
        ];

        for (let trend of trends) {
           // console.log('loadTrendCharts', getCategoryTrendConfig(dataset, trend.category, trend.group));
           // console.log('dataset, trend.category, trend.group ->', dataset, trend.category, trend.group);
            // @ts-ignore
            new Chart(document.getElementById(scopedId(trend.id)), getCategoryTrendConfig(dataset, trend.category, trend.group))
        }
    }

    /**
     * Load grade charts for a specific dataset
     */
    function loadGradeCharts(dataset: string) {
        getGradeCharts(dataset);
    }

    /**
     * Load trend tables for a specific dataset
     */
    function loadTrendTables(dataset: string) {
        createTrendTables(dataset);
    }

    $(document).ready(function () {
        // Initialize lazy loading filters instead of loading all charts
         initFilters();
    });

    function showSnapshot() {
        $('#' + scopedId('sat-math-trend-select')).removeClass("active");
        $(parentScope).find(".iar-math-school-trends, .iar-math-network-trends, .iar-math-district-trends").hide();
        $(parentScope).find(".iar-math-snapshot").show();
        $('#' + scopedId("iar-math-show-snapshot")).addClass("active");
    }

    function showTrends(event) {
        let selected = event.target.value;
        $('#' + scopedId("iar-math-show-snapshot")).removeClass("active");
        $(parentScope).find(".iar-math-snapshot").hide();
        $('#' + scopedId('iar-math-trend-select')).addClass("active");
        $(parentScope).find(".iar-math-school-trends, .iar-math-network-trends, .iar-math-district-trends").hide();
        $(parentScope).find('.iar-math-' + selected + '-trends').show();
    }

    function displayTrend(value) {
        $('#' + scopedId("iar-math-show-snapshot")).removeClass("active");
        $(parentScope).find(".iar-math-snapshot").hide();
        $('#' + scopedId('iar-math-trend-select')).addClass("active");
        $(parentScope).find('.iar-math-' + value + '-trends').show();
    }

    function hideTrendCharts() {
        $(parentScope).find("div.iar-math-all, div.iar-math-economic,div.iar-math-english,div.iar-math-gender,div.iar-math-grade, div.iar-math-iep,div.iar-math-race,div.iar-math-temporary").hide();
    }

    function setTrendChart() {
        hideTrendCharts();
        switch (selectedCategory) {
            case "ALL":
                $(parentScope).find("div.iar-math-all").show();
                break;
            case "Race/Ethnicity":
                $(parentScope).find("div.iar-math-race").show();
                break;
            case "Economic Disadvantage":
                $(parentScope).find("div.iar-math-economic").show();
                break;
            case "English Learner Status":
                $(parentScope).find("div.iar-math-english").show();
                break;
            case "Gender":
                $(parentScope).find("div.iar-math-gender").show();
                break;
            case "Grade Level":
                $(parentScope).find("div.iar-math-grade").show();
                break;
            case "IEP Status":
                $(parentScope).find("div.iar-math-iep").show();
                break;
            case "Temporary Living Situation Status":
                $(parentScope).find("div.iar-math-temporary").show();
                break;
        }
    }
}